/* @flow */

import React, { Component } from 'react';
import type { $Configuration } from '../../types/Configuration';
import type { $Dealer } from '../../types/Dealer';
import type { $DealerHighlightedActivityType } from '../../constants/DealerHighlightedActivityTypes';
import DealerHighlightedActivityTypes from '../../constants/DealerHighlightedActivityTypes';
import WorkbenchIcon from '../WorkbenchIcon/WorkbenchIcon';
import { renderHightlightedActivityIcon } from './DealerHighlightedActivitiesUtils';

type $Props = {
  configuration: $Configuration,
  marketCode: string,
  dealer: $Dealer,
  widgetSettings: Object,
  modifierClass?: string
};

export default class DealerHighlightedActivities extends Component<$Props> {

  render() {

    const { configuration, marketCode, dealer, widgetSettings, modifierClass } = this.props;
    const className = 'dl-dealer-highlighted-activities' + (modifierClass ? ' ' + modifierClass : '');

    const highlightedActivityTypes = DealerHighlightedActivityTypes.map((activity: $DealerHighlightedActivityType) => {
      if (renderHightlightedActivityIcon(activity, dealer, configuration, marketCode, widgetSettings)) {
        return (
          <WorkbenchIcon icon={ activity.icon } modifierClass={ activity.modifierClass } key={ activity.code } />
        );
      }
    });

    const highlightedActivityTypesIcons = highlightedActivityTypes.filter(activityType => activityType);

    return highlightedActivityTypesIcons.length > 0 ? (
      <div className={className}>
        { highlightedActivityTypesIcons }
      </div>
    ) : null;
  }
}
